<div class="modal-header"><h4 class="modal-title">Bulk Update Results</h4></div>
<div class="modal-body">
    @if (params.outcome.rereview.requested) {
        <p [class.text-success]="params.outcome.rereview.status === 'succeeded'" [class.text-danger]="params.outcome.rereview.status === 'failed'">
            <i class="fa" [class.fa-check-circle]="params.outcome.rereview.status === 'succeeded'" [class.fa-times-circle]="params.outcome.rereview.status === 'failed'"></i>
            Mark Rereviewed {{ params.outcome.rereview.status === 'succeeded' ? 'completed successfully.' : 'could not be completed.' }}
        </p>
    }
    @if (params.outcome.approver.requested) {
        <p
            [class.text-success]="params.outcome.approver.status === 'succeeded'"
            [class.text-warning]="params.outcome.approver.status === 'partially-succeeded'"
            [class.text-danger]="params.outcome.approver.status === 'failed'"
        >
            <i
                class="fa"
                [class.fa-check-circle]="params.outcome.approver.status === 'succeeded'"
                [class.fa-exclamation-triangle]="params.outcome.approver.status === 'partially-succeeded'"
                [class.fa-times-circle]="params.outcome.approver.status === 'failed'"
            ></i>
            @if (params.outcome.approver.status === 'succeeded') {
                {{ params.outcome.approver.result?.successCount ?? 0 }} payment{{ params.outcome.approver.result?.successCount !== 1 ? 's' : '' }} updated with the payment approver.
            } @else if (params.outcome.approver.status === 'partially-succeeded') {
                {{ params.outcome.approver.result?.successCount ?? 0 }} payment{{ params.outcome.approver.result?.successCount !== 1 ? 's' : '' }} updated; some payments could not be updated.
            } @else {
                Payment Approver could not be completed.
            }
        </p>
        @if (approverFailures.length) {
            <p class="text-warning">The following payments could not be updated:</p>
            <ul class="list-unstyled">
                @for (failure of approverFailures; track failure.paymentId) {
                    <li><strong>Payment ID {{ failure.paymentId }}:</strong> {{ failure.reason }}</li>
                }
            </ul>
        }
    }
</div>
<div class="modal-footer"><button type="button" class="btn btn-primary" (click)="close()">Close</button></div>
